import React from 'react'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import { Alert } from '@carsys/ui'
import { useArrowScrollHandler } from '@carsys/ui/src/helpers/keyboard/use-arrow-scroll-handler'
import { useFilter } from 'app/hooks/useFilter'
import { IModel } from '@cbgms/api/modules/vehicles'
import { ModelChip } from './ModelChip'
import Box from '@mui/material/Box'
import { Stack } from '@mui/material'
import { SearchFilter } from '../../fields/SearchFilter'

interface IModelSelectionProps {
  onModelSelect: (modelKey: string, model: IModel) => void
  selectedKey?: string
  models: IModel[]
  hideSearch?: boolean
}

export const ModelChips: React.FC<IModelSelectionProps> = ({ onModelSelect, selectedKey, models, hideSearch }) => {
  const { t } = useTranslation()
  const [filteredTableData, setFilter, filter] = useFilter(models)
  const { currentFocus } = useArrowScrollHandler(filteredTableData.length)

  return (
    <Stack spacing={2} sx={{ minHeight: 0 }}>
      {!hideSearch && (
        <Grid item xs={12}>
          <SearchFilter filter={filter} setFilter={setFilter} placeholder={t('Vehicle.SearchModel')} name='model-selection-search' />
        </Grid>
      )}
      <Box sx={{ minHeight: 0, overflow: 'auto' }} data-testid='modelselection'>
        <Grid container spacing={2} data-testid='select-chip-grid'>
          {filteredTableData.map((item, index: number) => (
            <ModelChip
              key={index}
              model={item}
              selectedKey={selectedKey}
              focus={currentFocus === index || filteredTableData.length === 1}
              onModelSelect={onModelSelect}
            />
          ))}
          {filteredTableData.length === 0 && (
            <Grid item xs={12}>
              <Alert severity='info' data-testid='no-results'>
                {t('global.search_no_results_found')}
              </Alert>
            </Grid>
          )}
        </Grid>
      </Box>
    </Stack>
  )
}
